/* eslint-disable class-methods-use-this */
/* eslint-disable no-useless-constructor */
import { Dialog } from '../../../core/view';

export default class PlanPictureDialog extends Dialog {
  public image:string = null;

  /**
   * コンストラクタ
   */
  constructor(draggable) {
    super(draggable);
  }

  /**
   *  内容の追加
   */
  buildContent() {
    // ダイアログのコンテンツ生成
    const id: string = 'documentPicture';

    //画像
    const imgElement: HTMLImageElement = document.createElement('img') as HTMLImageElement;
    imgElement.src = this.image;
    imgElement.style.maxWidth = `${(window.innerWidth - 100).toString()}px`;
    imgElement.style.maxHeight = `${(window.innerHeight - 100).toString()}px`;


    // タイトル
    let title: string = '';
    let contents:string = '<div class="pictureDetail">\n';
    contents += imgElement.outerHTML;
    contents += '</div>\n';

    let footer: string = '';

    this.createDialog(id, title, contents, footer);
  }


}
